import {
  PrinterOutlined,
  WarningOutlined,
  HeartOutlined,
  HeartFilled,
} from "@ant-design/icons";
import { Button } from "antd";
import { Link } from "react-router-dom";
import { ReportLoadStatus } from "../../store";
import { trackReportPrint } from "../../analytics";
import ShareButton from "./ShareButton";
import BugReportButton from "./BugReportButton";
import FileUploadButton from "./FileUploadButton";

interface FavoriteButtonProps {
  isFavorite: boolean;
  loading: boolean;
  onClick: () => void;
}

const FavoriteButton: React.FC<FavoriteButtonProps> = ({
  isFavorite,
  onClick,
}) => (
  <Button
    type="default"
    onClick={onClick}
    icon={
      isFavorite ? (
        <HeartFilled style={{ color: "#ff4444" }} />
      ) : (
        <HeartOutlined />
      )
    }
    className="favorite-upload-button"
    title={isFavorite ? "Remove from favorites" : "Add to favorites"}
    aria-label={isFavorite ? "Remove from favorites" : "Add to favorites"}
  />
);

interface AnalysisHeaderProps {
  analysisId: string;
  loadStatus: ReportLoadStatus;
  errorMsg: string | null;
  isFavorite: boolean;
  favoriteLoading: boolean;
  onFavoriteToggle: () => void;
}

const AnalysisHeader: React.FC<AnalysisHeaderProps> = ({
  analysisId,
  loadStatus,
  errorMsg,
  isFavorite,
  favoriteLoading,
  onFavoriteToggle,
}) => {
  const isLoaded = loadStatus === ReportLoadStatus.REPORT_LOADED;
  const isError = loadStatus === ReportLoadStatus.ERROR_LOADING_REPORT;

  return (
    <div className="flex-column">
      <div className="flex-space-between main-navbar">
        <h1 className="main-title-text" id="h1-title">
          Analysis Report
        </h1>
        <div className="upload-section">
          <BugReportButton />
          <ShareButton analysisId={analysisId} />
          <FavoriteButton
            isFavorite={isFavorite}
            loading={favoriteLoading}
            onClick={onFavoriteToggle}
          />
          <FileUploadButton disabled={!isLoaded} />
        </div>
      </div>
      <p className="main-text">
        Fast and scalable unknown malware detection for ALL of your files
      </p>
      {isError && (
        <div className="error-container">
          <h2
            className="flex-justify-center error"
            style={{ alignItems: "center" }}
          >
            <WarningOutlined style={{ fontSize: "28px", marginRight: "8px" }} />
            {errorMsg
              ? `Error - ${errorMsg}`
              : "Sorry, the analysis could not be loaded"}
          </h2>
          <Link to="/" id="home-lnk" className="go-home-button">
            Go back to homepage
          </Link>
        </div>
      )}
    </div>
  );
};

export default AnalysisHeader;
